// extracted by css-extract-rspack-plugin
export default {"defaultLink":"SignInWithRecoveryCode_defaultLink__QNpO2","centeredLink":"SignInWithRecoveryCode_centeredLink__x3IFY","passwordText":"SignInWithRecoveryCode_passwordText__gEZEl"};